import { AfterContentInit, Component, OnInit } from '@angular/core';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';
// @ts-expect-error - parallax-js lacks type definitions
import Parallax from 'parallax-js';

@Component({
    standalone: false,
    selector: 'core-block-flex-hero',
    templateUrl: './block-flex-hero.component.html',
})
export class BlockFlexHeroComponent extends BlockAbstractComponent implements OnInit, AfterContentInit {
    ngAfterContentInit() {
        const heroScene = document.getElementById('heroScene');
        const parallaxInstance = new Parallax(heroScene, {
            relativeInput: true,
            hoverOnly: true,
        });
    }
}
